import React from 'react';
import SidebarInput from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/SidebarInput';
import { SlSidebarScrollableContainer } from 'src/components/BeaconV2Components/SlSidebar';
import CheckboxItem from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/CheckboxItem';

interface RetailersFiltersProps {
  search: string;
  onSearchChange: (v: string) => void;
  availableCountries: { id: string; label: string }[];
  selectedCountries: string[];
  onToggleCountry: (id: string) => void;
  availableIndustries: { id: string; label: string }[];
  selectedIndustries: string[];
  onToggleIndustry: (id: string) => void;
}

const RetailersFilters: React.FC<RetailersFiltersProps> = ({
  search,
  onSearchChange,
  availableCountries,
  selectedCountries,
  onToggleCountry,
  availableIndustries,
  selectedIndustries,
  onToggleIndustry
}) => {
  const [countrySearch, setCountrySearch] = React.useState('');
  const handleClearCountries = () => selectedCountries.forEach((id) => onToggleCountry(id));
  const filteredCountries = React.useMemo(() => {
    const q = (countrySearch || '').toLowerCase();
    if (!q) return availableCountries;
    return availableCountries.filter((c) => c.label.toLowerCase().includes(q));
  }, [availableCountries, countrySearch]);

  return (
    <div style={{ marginTop: 75, width: '100%' }}>
      {/* Search Retailers */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#031425' }}>Search Retailers</div>
        {search ? (
          <span
            onClick={() => onSearchChange('')}
            style={{ color: '#4E6980', fontSize: 12, cursor: 'pointer' }}
          >
            Clear
          </span>
        ) : null}
      </div>
      <div style={{ marginTop: 6, width: '100%' }}>
        <SidebarInput
          placeholder="Search retailers to include"
          value={search}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
          sx={{ width: '100%' }}
        />
      </div>

      {/* Countries (styled like Brands/Categories) */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 36, marginBottom: 4 }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#031425' }}>Countries</div>
        {selectedCountries.length > 0 ? (
          <span
            onClick={handleClearCountries}
            style={{ color: '#4E6980', fontSize: 12, cursor: 'pointer', marginLeft: 8 }}
          >
            Clear
          </span>
        ) : null}
      </div>
      {/* Country search */}
      <div style={{ marginTop: 6 , marginBottom: 16}}>
        <SidebarInput
          placeholder="Refine by countries"
          value={countrySearch}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCountrySearch(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <SlSidebarScrollableContainer style={{ maxHeight: 224, paddingRight: 6 }}>
        {filteredCountries.map((c) => (
          <div key={c.id} style={{ marginBottom: 6 }}>
            <CheckboxItem
              label={c.label}
              value={c.id}
              checked={selectedCountries.includes(c.id)}
              onClick={() => onToggleCountry(c.id)}
            />
          </div>
        ))}
      </SlSidebarScrollableContainer>

      {/* <div style={{ marginTop: 16, fontWeight: 700, fontSize: 12, color: '#031425', marginBottom: 4 }}>Industries</div>
      <div style={{ color: '#8A98AA', fontSize: 12, marginBottom: 8 }}>Refine by industries</div>
      <div style={{ maxHeight: 220, overflow: 'auto', paddingRight: 6 }}>
        {availableIndustries.map((i) => (
          <label key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={selectedIndustries.includes(i.id)}
              onChange={() => onToggleIndustry(i.id)}
            />
            <span style={{ fontSize: 14 }}>{i.label}</span>
          </label>
        ))}
      </div> */}
    </div>
  );
};

export default RetailersFilters;


